
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import Qrcode from '@xt/www/components/showQrcode/index.vue'

@Component({
  components: {
    Qrcode,
    LazyImg
  }
})
export default class extends Vue {
  @Prop() dataSource

  handleSelf() {
    window.open('https://mp.weixin.qq.com/s/dzc9VY8N9Mdj6QVjOaQlVg')
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
